import React from 'react';

export function NotFoundPage() {
    return (
        <div>
            <span>404</span>
        </div>
    );
}
